import request from '@/utils/request'

const prefix = '/django_rest/client-admin/ads-tier'

export default {
  getAdsTierInfo (params) {
    return request.get(`${prefix}/`, { params })
  },
  saveAdsTierOrder (params) {
    return request.put(`${prefix}/`, params)
  }
}
